<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
        {{ folder.id ? $t('folders.add_modal.edit') : $t('folders.add_modal.create')}}
      </h5>
    </template>

    <template #body>
      <form @submit.prevent="createOrUpdateFolder($event)">
        <div class="modal-body">
          <div class="form-group">
            <label for="folder_name" class="col-form-label">
              {{ $t('folders.add_modal.folder_name')}}
            </label>

            <input type="text" name="folder[name]" class="form-control" required="required" v-model='folder.name' />
          </div>

          <div class="form-group">
            <label for="folder_contact" class="col-form-label">
              {{ $t('folders.add_modal.contact')}}
            </label>

            <div>
              <single-select :template='contactTemplate' :getter='getContacts' name='folder[contact_id]' v-model='contact' />
            </div>
          </div>

          <div class="form-group">
            <label for="folder_contact" class="col-form-label">
              {{ $t('root.add_parent')}}
            </label>

            <div>
              <input type='hidden' name='folder[folder_id]' value='' />
              <single-select :template='folderTemplate' :getter='getFolders' name='folder[folder_id]' v-model='currentParent' />
            </div>
          </div>

          <p>
            <strong>{{$t('folders_list.benefits_of_connecting.description')}}</strong>
            <ul>
              <li>{{$t('folders_list.benefits_of_connecting.organize')}}</li>
              <li>{{$t('folders_list.benefits_of_connecting.filter_by')}}</li>
            </ul>
          </p>
        </div>

        <div class="modal-footer">
          <input type="submit" name="commit" :value="$t('folders.add_modal.save')" class="btn btn-primary float-right" :disabled='isProcessing'>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'
  import _single_select from '../_infinite_single_select'

  export default {
    components: {
      modal: _modal,
      'single-select': _single_select,
    },
    data() {
      return {
        folder: {},
        contact: {},
        currentParent: {},
        isProcessing: false,
      }
    },
    methods: {
      open(folder, parentFolder) {
        this.folder = Object.assign({ breadcrumbs: [] }, folder)
        this.currentParent = parentFolder

        if (this.folder.contact_id)
          this.store.getContact(this.folder.contact_id).then(() => {
            this.contact = this.state.contact
          })

        if (!this.currentParent)
          this.listStore.getFolder('root').then((data) => {
            this.currentParent = data
          })

        this.$refs.modal.open()
      },
      getContacts(params) {
        return this.listStore.getContacts(params)
      },
      getFolders(params) {
        let heightParam = {}

        if (this.folder.folder_id)
          heightParam = { 'filters[id_not_in]': this.folder.id, 'filters[height_lteq]': this.folder.breadcrumbs.length }

        return this.listStore.getFolders(Object.assign(params, heightParam))
      },
      createOrUpdateFolder(e) {
        this.isProcessing = true

        const params = new FormData(e.target)
        if (this.parentFolder)
          params.append('folder[folder_id]', this.parentFolder.id)

        let promise
        if (this.folder.id) {
          promise = this.store.updateFolder(this.folder.id, params)
          this.store.sendMetrics({name: 'update_folder', params: this.$route.params, path: this.$route.fullPath})
        } else {
          promise = this.store.createFolder(params);
          this.store.sendMetrics({name: 'create_folder', params: this.$route.params, path: this.$route.fullPath})
        }

        promise.then((data) => {
          this.$emit('success')
          this.$refs.modal.close()
          if (!this.folder.id)
            this.$router.replace({ name: 'folder', params: { id: data.data.id } })
        }).finally(() => {
          this.isProcessing = false
        })
      }
    }
  }
</script>

<style lang='sass' scoped>
  p
    font-size: 12px
</style>

